import { render } from "./ShiftCard.vue?vue&type=template&id=4e4cad4a&scoped=true"
import script from "./ShiftCard.vue?vue&type=script&lang=js"
export * from "./ShiftCard.vue?vue&type=script&lang=js"

import "./ShiftCard.vue?vue&type=style&index=0&id=4e4cad4a&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4cad4a"]])

export default __exports__